// extracted by mini-css-extract-plugin
export var fadeIn = "_ml-1";
export var modalContent = "_ml-3";
export var overlay = "_ml-0";
export var popoverContent = "_ml-2";
export var results = "_ml-5";
export var searchInputWrapper = "_ml-4";